import { useState } from "react";
import TableRow from "@mui/material/TableRow";
import IconButton from "@mui/material/IconButton";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import LinkedInAssetsGroupRow from "./LinkedInAssetsGroupRow";
import { useFormContext } from "react-hook-form";
import { getFromStatisticsAdsCampaign } from "../../../../../services/adsCampaigns";
import { LINKEDIN } from "../../../../../utils/constants";
import { useTranslationApp } from "../../../../../lib/i18next";
import TableCell from "../../../../BillingAndPayments/components/TableCell";
import { expanderColumnSx, metricColumnSx } from "../columnWidths";
import Box from "@mui/material/Box";
import Avatar from "@mui/material/Avatar";
import { logoPlatform } from "../../../../../utils/string";
import Typography from "@mui/material/Typography";
import { renderMetricValue } from "../../../../../utils/renderMetricValue";
import {
  resolveCampaignLevelStatistics,
  resolveStatisticsMap,
} from "../../../../NewAdsCampaign/components/Common/campaignLevelMetrics";

const LinkedInCampaignRow = ({ index, sortConfig, columns }) => {
  const [open, setOpen] = useState(false);
  const { campaign } = useFormContext();
  const { statistics } = getFromStatisticsAdsCampaign(campaign);

  const { t } = useTranslationApp();

  const conversionActions =
    campaign?.platformsData?.[LINKEDIN]?.conversionActions;
  const statisticsPlatform = resolveCampaignLevelStatistics({
    raw: statistics[LINKEDIN]?.campaign || {},
    platform: LINKEDIN,
    conversionActions,
  }).statistics;
  const assetsGroupStatisticsById = resolveStatisticsMap(
    statistics[LINKEDIN]?.assetsGroups,
    LINKEDIN,
    conversionActions
  );
  const assetsGroups = campaign.assetsGroups || [];
  const assetsGroupsLinkedIn = assetsGroups.filter(
    (assetsGroup) => assetsGroup.platform === LINKEDIN
  );

  // Sort asset groups
  const sortedAssetsGroups = [...assetsGroupsLinkedIn].sort((a, b) => {
    const aStats = assetsGroupStatisticsById[a.id];
    const bStats = assetsGroupStatisticsById[b.id];

    if (!aStats || !bStats) return 0;

    if (sortConfig.key) {
      const comparison =
        (aStats[sortConfig.key] || 0) - (bStats[sortConfig.key] || 0);
      return sortConfig.direction === "asc" ? comparison : -comparison;
    }
    return 0;
  });

  // Mapeo para renderizar cada celda según la columna
  const cellRenderers = {
    platform: () => (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          gap: 1,
          height: "100%",
          width: "100%",
        }}
      >
        <Avatar
          data-hide-in-pdf-capture
          src={logoPlatform(LINKEDIN)}
          variant="square"
          sx={{
            width: 20,
            height: 20,
            ".MuiAvatar-img": { objectFit: "contain" },
          }}
        />
        <Typography variant="body2" sx={{ mt: 0.25 }}>
          {t(LINKEDIN)}
        </Typography>
      </Box>
    ),
    costPerMainAction: () =>
      renderMetricValue(
        statisticsPlatform.costPerMainAction,
        "costPerMainAction",
        statisticsPlatform.currency
      ),
  };

  return (
    <>
      <TableRow>
        <TableCell indexRow={index} sx={expanderColumnSx} level={1}>
          <IconButton size="small" onClick={() => setOpen(!open)}>
            {open ? <KeyboardArrowDownIcon /> : <KeyboardArrowRightIcon />}
          </IconButton>
        </TableCell>
        {columns.map((col) => (
          <TableCell
            key={col.key}
            indexRow={index}
            level={1}
            sx={metricColumnSx(col.width)}
          >
            {cellRenderers[col.key]
              ? cellRenderers[col.key]()
              : renderMetricValue(
                  statisticsPlatform[col.key],
                  col.key,
                  statisticsPlatform.currency
                )}
          </TableCell>
        ))}
      </TableRow>
      {open &&
        sortedAssetsGroups.map((assetsGroup, indexAssetsGroup) => {
          const assetsGroupID = assetsGroup.id;
          const assetsGroupStatistics =
            assetsGroupStatisticsById[assetsGroupID];

          if (!assetsGroupStatistics) return null;

          return (
            <LinkedInAssetsGroupRow
              indexCampaign={index}
              indexAssetsGroup={indexAssetsGroup}
              assetsGroupID={assetsGroupID}
              key={assetsGroup.id}
              data={assetsGroupStatistics}
              sortConfig={sortConfig}
              columns={columns}
            />
          );
        })}
    </>
  );
};

export default LinkedInCampaignRow;
